import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

const SingleItem = ({ data, handleClose }) => {
  const [livePrice, setLivePrice] = useState([]);
   const [loading, setLoading] = useState(true);
   const { popular_market_id: HotData } = data;
 
   useEffect(() => {
     const interval = setInterval(() => {
       fetchData();
     }, 1000);
     return () => clearInterval(interval);
   }, [livePrice]);
 
   const fetchData = async () => {
     if (HotData !== null) {
       if (HotData?.market === "Crypto") {
         fetch(
           `https://api.massive.com/v2/snapshot/locale/global/markets/crypto/tickers/X:${HotData?.symbol}${HotData?.currency}?apiKey=${process.env.REACT_APP_POLYGON_API_KEY}`,
           {
             method: "GET",
           }
         )
           .then((res) => res.json())
           .then((data) => {
             if (data?.ticker) {
               setLivePrice(data?.ticker);
             }
             if (loading) {
               setLoading(false);
             }
           })
           .catch((error) => {
             // console.log(error);
           });
       }
       if (HotData?.market === "Forex" || HotData?.market === "Metal") {
         fetch(
           `https://api.massive.com/v2/snapshot/locale/global/markets/forex/tickers/C:${HotData?.symbol}${HotData?.currency}?apiKey=${process.env.REACT_APP_POLYGON_API_KEY}`,
           {
             method: "GET",
           }
         )
           .then((res) => res.json())
           .then((data) => {
             if (data?.ticker) {
               setLivePrice(data?.ticker);
             }
             if (loading) {
               setLoading(false);
             }
           })
           .catch((error) => {
             // console.log(error);
           });
       }
       if (HotData?.market === "Stock") {
         fetch(
           `https://api.massive.com/v2/snapshot/locale/us/markets/stocks/tickers/${HotData?.symbol}?apiKey=${process.env.REACT_APP_POLYGON_API_KEY}`,
           {
             method: "GET",
           }
         )
           .then((res) => res.json())
           .then((data) => {
             if (data?.ticker) {
               setLivePrice(data?.ticker);
             }
             if (loading) {
               setLoading(false);
             }
           })
           .catch((error) => {
             // console.log(error);
           });
       }
     }
   };

  if (loading) {
    return;
  }

  return (
    <>
      <li>
        <NavLink
          onClick={handleClose}
          className="menu-item "
          to={`/user/trade/hot/${HotData?._id}`}
          end={true}
        >
          <div className="d-flex justify-content-between gap-1">
            <div className="text-xl">
              <span>{HotData?.name}</span>
              <span className="opacity-50 text-base font-light">
                <br /> {HotData?.symbol}
              </span>
            </div>
            <div className="d-flex justify-content-between mt-1">
              <div className="text-gray-400 font-light text-sm  trade-sidebar-price">
              {HotData?.market === "Forex" &&
              !isNaN(livePrice?.lastQuote?.a) &&
              parseFloat(livePrice?.lastQuote?.a) + parseFloat(HotData?.price)}

            {HotData?.market === "Metal" &&
              !isNaN(livePrice?.lastQuote?.a) &&
              parseFloat(livePrice?.lastQuote?.a) + parseFloat(HotData?.price)}

            {HotData?.market === "Crypto" &&
              !isNaN(livePrice?.lastTrade?.p) &&
              parseFloat(livePrice?.lastTrade?.p) + parseFloat(HotData?.price)}
            {HotData?.market === "Stock" &&
              !isNaN(livePrice?.lastTrade?.p) &&
              parseFloat(livePrice?.lastTrade?.p) + parseFloat(HotData?.price)}$
              </div>
            </div>
          </div>
        </NavLink>
      </li>
    </>
  );
};

export default SingleItem;
